
import { async_command_dispatcher } from "@/api/client"

export class SaveRepresentativeDNICommand {
    constructor(
        private frontend
    ) {}
    
    async run(dni_file_url, dni_file_name, company_id): Promise<any> {
        try {
            const args = {
                dni_file_url: dni_file_url,
                dni_file_name: dni_file_name,
                company_id: company_id
            }
            const response = await async_command_dispatcher.dispatch_with_result('save.dni.representative.facturae', args, 1500)
            return response
        }
        catch (error) {
            console.error("Error al guardar el DNI del representante", error)
            throw error
        }
    }
}